export default "__VITE_PUBLIC_ASSET__93a4b950__"